import { Contact } from '~api/address_book';
import { CarrierContract } from '~api/carrier_contracts';
import { ShippingMethod } from '~api/selfcare';
import {
  CreateCompositeShipmentRequest,
  CustomerInfo,
  CustomsDeclaration,
  DateTimeRange,
  Delivery,
  Dimensions,
  PickupLocationType,
  Shipment,
} from '~api/som';
import { Status } from '~api/som_search';
import { Order } from '~api/tos';
import { ShipmentTemplateWithTags } from '~api/userprofile';

import { useForm, useFormContext } from 'react-hook-form';

export const incoTerms = [
  'EXW',
  'FCA',
  'FAS',
  'FOB',
  'CFR',
  'CIF',
  'CPT',
  'CIP',
  'DAT',
  'DAP',
  'DDP',
  'DAF',
  'DDU',
  'DEQ',
  'DES',
  'DPU',
] as const;

export const contentsTypes = ['DOCUMENTS', 'GIFT', 'COMMERCIAL_SAMPLE', 'SALE', 'RETURN', 'OTHER'] as const;

export type AddressType = 'contact_from' | 'contact_to' | 'contact_return' | 'customer_info.contact';

export type ShipmentUpsert = Omit<
  CreateCompositeShipmentRequest,
  'tos_id' | 'shipping_method' | 'address_from' | 'address_to' | 'address_return' | 'customer_info'
> & {
  shipment_id?: string;
  tos?: Order;
  template?: ShipmentTemplateWithTags;
  contact_from?: Contact;
  contact_to?: Contact;
  contact_return?: Contact;
  customer_info?: Omit<CustomerInfo, 'address'> & { contact?: Contact };
  shipping_method?: ShippingMethod;
  carrier_contract?: CarrierContract;
};

export type ShipmentDetails = Omit<
  Shipment,
  'tos_id' | 'address_from' | 'address_to' | 'address_return' | 'customer_info' | 'status'
> & {
  tos: Order;
  contact_from?: Contact;
  contact_to?: Contact;
  contact_return?: Contact;
  customer_info?: Omit<CustomerInfo, 'address'> & { contact?: Contact };
  shipping_method: ShippingMethod;
  carrier_contract?: CarrierContract;
  delivery_time?: DateTimeRange;
  customs_declaration?: CustomsDeclaration;
  weight?: number;
  dimensions?: Dimensions;
  status: {
    type: Status;
    message?: string;
  };
  deliveries: Delivery[];
  location_ref?: string;
  location_type?: PickupLocationType;
};

export const useShipmentForm = useForm<ShipmentUpsert>;
export const useShipmentFormContext = useFormContext<ShipmentUpsert>;
